import React, { useState } from "react";
import Chart from "react-apexcharts";

const BarChart = ({
  horizontalBar = false,
  categories,
  data,
  colors,
  yTitle,
  tooltipFormatter,
  useGradient = false,
  height,
  showSeriesNameOnHover = true,
}) => {
  const [options] = useState({
    chart: {
      type: "bar",
      toolbar: {
        show: false,
      },
      height: "100%",
      zoom: {
        enabled: false,
      },
    },
    legend: {
      show: false,
    },
    xaxis: {
      categories: categories,
    },
    yaxis: {
      title: {
        text: yTitle,
      },
      labels: {
        formatter: (val) => val,
      },
    },
    plotOptions: {
      bar: horizontalBar
        ? {
            borderRadius: 4,
            borderRadiusApplication: "end",
            horizontal: true,
          }
        : {
            borderRadius: 0,
            dataLabels: {
              position: "top",
            },
          },
    },
    dataLabels: {
      enabled: true,
      offsetY: -0,
      style: {
        fontSize: "10px",
        colors: ["#fff"],
      },
    },
    grid: {
      show: true,
      borderColor: "#56577A",
      strokeDashArray: 5,
      position: "back",
      xaxis: {
        lines: {
          show: false,
        },
      },
      yaxis: {
        lines: {
          show: true,
        },
      },
      row: {
        colors: undefined,
        opacity: 0.5,
      },
      column: {
        colors: undefined,
        opacity: 0.5,
      },
      padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
      },
    },
    colors: colors,
    tooltip: {
      enabled: true,
      theme: "dark",
      y: {
        formatter: tooltipFormatter,
        ...(showSeriesNameOnHover
          ? {}
          : {
              title: {
                formatter: () => "",
              },
            }),
      },
      style: {
        fontSize: "10px",
      },
      marker: {
        show: false,
      },
      x: {
        show: false,
      },
      position: "left",
    },
    fill: useGradient
      ? {
          type: "gradient",
          gradient: {
            shade: "light",
            type: "vertical",
            shadeIntensity: 0.3,
            gradientToColors: ["#fff"],
            inverseColors: false,
            opacityFrom: 0.9,
            opacityTo: 0.2,
            stops: [0, 100],
          },
        }
      : { type: "solid" },
  });

  return (
    <div className="chartWrapper">
      <Chart options={options} series={data} type="bar" width="100%" height="100%" />
    </div>
  );
};

export default BarChart;
